import styled from 'styled-components';
import { Layout } from 'antd';

export const StyledLayout = styled(Layout)`
  height: 100%;
  flex-direction: column;
  overflow: auto;

  .layout-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;
